const defaultColor = '#474B5A'
const primaryColor = '#F90037'
const desktopConfig = { minWidth: 992 }
const tabletConfig = { minWidth: 768, maxWidth: 991 }
const mobileConfig = { maxWidth: 767 }


export default {
  defaultColor,
  primaryColor,
  desktopConfig,
  tabletConfig,
  mobileConfig,
}